import { useState } from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { fmtDateTime } from "@/lib/intl";
import { Button } from "@/components/ui/button";
import { errMsg } from "./kpiFormat";

/** Red banner while last night's automatic sync has a failure that no later sync has fixed. */
export const NightlySyncAlert = ({ status, onOpenSources }) => {
  const [hidden, setHidden] = useState(false);
  const [busy, setBusy] = useState(false);
  if (hidden || !status?.failing?.length) return null;
  const sync = async () => {
    setBusy(true);
    try {
      await api.post("/kpi/sync");
      toast.success("Sync started — this can take a minute");
      setHidden(true);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const when = status.last_run?.started_at;
  return (
    <div role="alert" className="flex flex-wrap items-start justify-between gap-3 rounded-md border border-red-200 bg-red-50 p-4 text-sm text-red-900"
      data-testid="kpi-nightly-alert">
      <div className="flex gap-2">
        <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" />
        <div>
          <div className="font-medium">The automatic nightly sync failed{when ? ` (${fmtDateTime(when)})` : ""} — figures may be out of date</div>
          <ul className="mt-1 space-y-0.5 text-xs text-red-800">
            {status.failing.map((f) => (
              <li key={f.source || "run"} data-testid={`kpi-nightly-alert-source-${f.source || "run"}`}><b>{f.label}</b>: {f.error}</li>
            ))}
          </ul>
        </div>
      </div>
      <div className="flex gap-2">
        <Button size="sm" variant="outline" className="bg-white" onClick={onOpenSources} data-testid="kpi-nightly-alert-sources">View data sources</Button>
        <Button size="sm" onClick={sync} disabled={busy} data-testid="kpi-nightly-alert-sync"><RefreshCw className="mr-1.5 h-3.5 w-3.5" />Sync now</Button>
      </div>
    </div>
  );
};
